import request from '@/utils/request'

export function resetPassword(oldPassword, newPassword) {
  return request({ url: 'user/user_info', method: 'post', data: { oldPwd: oldPassword, newPwd: newPassword }})
}

export function simpleResetPasswordApi(uuid) {
  return request({ url: `user/staffs/${uuid}`, method: 'post', data: { action: 'RESET_PWD' }})
}
